<script setup lang="ts">

</script>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: 'LoadingSpin',

    props: {
        size: {
            type: Number,
            required: false,
            default: 30,
        },

        centerAligned: {
            type: Boolean,
            required: false,
            default: true,
        },

        margin: {
            type: Number,
            required: false,
            default: 15,
        },
    }
})
</script>

<template>
    <div
        class="loading"
        :class="{
            center: centerAligned
        }"
        :style="{
            width: `${size}px`,
            height: `${size}px`,
            margin: `${margin}px`,
        }"
    >
        <div class="spinner spinner-border text-light align-middle align-items-center" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<style scoped>
.loading {
    margin: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading.center {
    margin-left: auto !important;
    margin-right: auto !important;
}

.spinner {
    width: 100%;
    height: 100%;
}
</style>